import React from "react";
import NavBar from "../../components/Navbar/NavBar";


const ToolsSellBanner = () => {
    return (
        <>
            <div className="toolsSellBanner" id="toolSell">
                <div>
                    <NavBar/>
                </div>

                <div
                    className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 h-5/6"
                    data-aos="zoom-in"
                >
                    <div
                        className="flex flex-col lg:flex-row py-8 justify-between text-center lg:text-left"
                    >
                        <div
                            className="lg:w-1/2 flex flex-col justify-center "
                            data-aos="zoom-in"
                            data-aos-delay="200"
                        >
                            <span className="mb-5 md:text-5xl text-3xl font-bold text-white bannerText">
                                Vitajte
                            </span>
                            <div className="text-xl font-semibold tracking-tight mb-5 text-white bannerText">
                                <p>Potrebujete pracovné náradie?</p> Elektrické, ručné náradie, AKU náradie, TK plátky,
                                meradlá, rezné a brúsne kotúče, diamantové kotúče, frézy, vrtáky alebo dokonca rezanie a
                                delenie materiálu vodným lúčom?
                                <p data-aos="zoom-in"
                                   data-aos-delay="500">Ste tu správne!</p>

                            </div>

                        </div>
                        <div
                            className="flex lg:justify-end w-full lg:w-1/2"
                            data-aos="fade-up"
                            data-aos-delay="700"
                        >
                            {/*<img*/}
                            {/*    alt="card img"*/}
                            {/*    className="rounded-t float-right duration-1000 w-full"*/}
                            {/*    src={heroImg}*/}
                            {/*/>*/}
                            <div style={{height: "406px"}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ToolsSellBanner;
